// polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import smoothscroll from 'smoothscroll-polyfill';
import 'intersection-observer';

import Vue from 'vue';

import breakpoint from '@/services/breakpoint';
import resizeMixin from '@/mixins/resize';

// Main app
import App1 from './App1BubbleCluster.vue';
import App2 from './App2BubbleGrid.vue';
import App3 from './App3Line.vue';
import App4 from './App4Bar.vue';
import App5 from './App5StackedBar.vue';
import App6 from './App6Grid.vue';

import '@/styles/main.scss';

// kick off the polyfill
smoothscroll.polyfill();

// register global mixin
Vue.mixin({
  beforeCreate() {
    this.$breakpoint = Vue.observable(breakpoint);
  },
  ...resizeMixin,
});

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App1),
}).$mount('#app-viz-bubble-cluster');

new Vue({
  render: (h) => h(App2),
}).$mount('#app-viz-bubble-grid')

new Vue({
  render: (h) => h(App3),
}).$mount('#app-viz-line-chart')

new Vue({
  render: h => h(App4),
}).$mount('#app-viz-bar-chart')

new Vue({
  render: h => h(App5),
}).$mount('#app-viz-stackedbar-chart')

new Vue({
  render: h => h(App6),
}).$mount('#app-viz-grid')